<template>
  <EditorPromoCodeCard
    v-bind="{ conditionMessage, coupon, errorMessage, verdict }"
    ref="card"
    :loading="isLoading"
    @apply="apply($event, true)"
    @clear-error="errorMessage = null"
    @remove="remove"
  />
</template>

<script lang="ts" setup>
import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

type Props = {
  lotteryId: LotteryId
}

const { lotteryId } = defineProps<Props>()

const { apply, conditionMessage, coupon, errorMessage, isLoading, onExpired, remove, verdict } =
  useEditorPromoCode(lotteryId)

const card = useTemplateRef('card')

onExpired(() => card.value?.collapse())
</script>
